import { combineReducers, createStore, applyMiddleware } from 'redux';
import { Provider, Store } from 'react-redux';
import thunk from 'redux-thunk';
import findAPDApiReducer from './reducers/find-a-pd-api';
import findAPDSettingsReducer from './reducers/find-a-pd-settings';
import { FindAPDApiModel, defaultFindAPDApiModel } from './reducers/find-a-pd-api';
import { FindAPDSettingsModel, defaultFindAPDSettingsModel } from './reducers/find-a-pd-settings';
import { getDentists, getSettings } from './actions/find-a-dentist-api';
import paginationReducer from "./reducers/pagination-reducer";
import { FindAPDAppState } from '../classes/redux-states';
import filtersReducer from "./reducers/filters-reducer";

let combined = combineReducers({
    findAPDApiModel: findAPDApiReducer,
    findAPDSettingsModel: findAPDSettingsReducer,
    findAPDPaginationModel: paginationReducer,
    findAPDFiltersModel: filtersReducer
})

var dentistsStore = createStore(combined, applyMiddleware(thunk)) as Store<any>;

var previousState = dentistsStore.getState();

dentistsStore.subscribe(() => {
    const currentState = dentistsStore.getState();
    const apiModel = currentState as FindAPDAppState;
    const prevApiModel = previousState as FindAPDAppState;

    if (apiModel.findAPDPaginationModel.currentPage != prevApiModel.findAPDPaginationModel.currentPage && !apiModel.findAPDApiModel.requestingData) {
        dentistsStore.dispatch(getDentists(0));
        dentistsStore.dispatch(getSettings());
    }
    //update here for filtering
    previousState = currentState;
})

export { dentistsStore }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/redux/index.ts